// Payment method icons — inline SVGs so no external network requests.
// Displays: Euro (bank transfer), Multibanco, VISA, MasterCard.
// Colours use theme tokens so it looks OK on both dark and light modes.

const pillCls =
  "flex h-9 w-14 items-center justify-center rounded-md bg-white shadow-sm ring-1 ring-black/5 dark:ring-white/10";

export const PaymentMethods = ({ className = "", size = "md" }) => {
  const h = size === "sm" ? "h-8 w-12" : "h-9 w-14";
  const box = `flex ${h} items-center justify-center rounded-md bg-white shadow-sm ring-1 ring-black/5 dark:ring-white/10`;
  return (
    <div
      data-testid="payment-methods"
      className={`flex flex-wrap items-center gap-2 ${className}`}
      aria-label="Métodos de pagamento aceites: Multibanco, Visa, MasterCard e transferência bancária"
    >
      {/* Euro / bank transfer */}
      <div className={box} title="Transferência bancária / Numerário">
        <svg viewBox="0 0 32 32" className="h-5 w-5" aria-hidden="true">
          <circle cx="16" cy="16" r="14" fill="#F5B301" />
          <path
            d="M20.5 20.5c-1 .9-2.3 1.4-3.7 1.4-2.7 0-4.9-1.8-5.6-4.3H16v-1.4h-5.1c0-.2 0-.4-.1-.6 0-.2 0-.4.1-.6H16v-1.4h-4.8c.7-2.5 2.9-4.3 5.6-4.3 1.4 0 2.7.5 3.7 1.4l1.1-1.4c-1.3-1.1-3-1.8-4.8-1.8-3.6 0-6.6 2.5-7.4 5.9H8v1.6h1.3c0 .2 0 .4 0 .6 0 .2 0 .4 0 .6H8v1.6h1.4c.8 3.4 3.8 5.9 7.4 5.9 1.8 0 3.5-.7 4.8-1.8l-1.1-1.4z"
            fill="#0057A6"
          />
        </svg>
      </div>

      {/* Multibanco (MB) */}
      <div className={box} title="Multibanco (MB)">
        <svg viewBox="0 0 60 32" className="h-5 w-9" aria-hidden="true">
          <rect x="0" y="0" width="60" height="32" rx="3" fill="#0033A0" />
          <text
            x="30"
            y="15"
            textAnchor="middle"
            fill="#ffffff"
            fontFamily="Helvetica, Arial, sans-serif"
            fontWeight="800"
            fontSize="12"
          >
            MB
          </text>
          <text
            x="30"
            y="26"
            textAnchor="middle"
            fill="#ffffff"
            fontFamily="Helvetica, Arial, sans-serif"
            fontWeight="600"
            fontSize="5"
            letterSpacing="1"
          >
            MULTIBANCO
          </text>
        </svg>
      </div>

      {/* VISA */}
      <div className={box} title="Visa">
        <svg viewBox="0 0 60 32" className="h-5 w-10" aria-hidden="true">
          <rect x="0" y="0" width="60" height="32" rx="3" fill="#ffffff" />
          <text
            x="30"
            y="22"
            textAnchor="middle"
            fill="#1A1F71"
            fontFamily="Helvetica, Arial, sans-serif"
            fontStyle="italic"
            fontWeight="900"
            fontSize="16"
            letterSpacing="1"
          >
            VISA
          </text>
        </svg>
      </div>

      {/* MasterCard */}
      <div className={box} title="MasterCard">
        <svg viewBox="0 0 60 32" className="h-6 w-10" aria-hidden="true">
          <circle cx="24" cy="16" r="9" fill="#EB001B" />
          <circle cx="36" cy="16" r="9" fill="#F79E1B" />
          <path
            d="M30 9.3a9 9 0 000 13.4 9 9 0 000-13.4z"
            fill="#FF5F00"
          />
        </svg>
      </div>
    </div>
  );
};

export default PaymentMethods;
